module.exports = __webpack_public_path__ + "static/media/concept-energy-label-ap.4225ea2f.svg";